import React, { Component } from 'react';
import Dictionary from '../model/Dictionary';
import { Button } from 'material-ui';
/**
 * ## Redux imports
 */
import * as globalActions from '../redux/actions/GlobalActions';
import { Map } from 'immutable';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import selectors from '../redux/selectors/Index';

class HomeScreen extends Component {
  render () {
    return (
      <div>
        <h3>{Dictionary.home.description}</h3>
        <Button variant='raised' color='primary'>
          <a onClick={() => this.props.actions.changeActiveStep('flights')}>
            {Dictionary.home.button}
          </a>
        </Button>

        <div style={{ marginTop: 50 }}>
          <button
            type='button'
            color='primary'
            className='btn btn-primary btn-sm'
            data-toggle='modal'
            data-target='#exampleModal'
          >
            Launch demo modal
          </button>
          <div
            className='modal fade'
            id='exampleModal'
            tabIndex='-1'
            role='dialog'
            aria-labelledby='exampleModalLabel'
            aria-hidden='true'
          >
            <div className='modal-dialog' role='document'>
              <div className='modal-content'>
                <div className='modal-header'>
                  <h5 className='modal-title' id='exampleModalLabel'>
                    Modal title
                  </h5>
                  <button type='button' className='close' data-dismiss='modal' aria-label='Close'>
                    <span aria-hidden='true'>&times;</span>
                  </button>
                </div>
                <div className='modal-body'>...</div>
                <div className='modal-footer'>
                  <button type='button' className='btn btn-secondary' data-dismiss='modal'>
                    Close
                  </button>
                  <button type='button' className='btn btn-primary'>
                    Save changes
                  </button>
                </div>
              </div>
            </div>
          </div>
          <a data-toggle='tooltip' title='Some tooltip text!' className='my-button'>
            Hover over me
          </a>
          <div className='tooltip bs-tooltip-top my-popper' role='tooltip'>
            <div className='arrow' />
            <div className='tooltip-inner'>Some tooltip text!</div>
          </div>
          <button
            type='button'
            className='btn btn-sm btn-danger my-button'
            data-toggle='popover'
            title='Popover title'
            data-content="And here's some amazing content. It's very engaging. Right?"
          >
            Click to toggle popover
          </button>
        </div>
      </div>
    );
  }
}

/**
 * ## Redux boilerplate
 */
const actions = [ globalActions ];

function mapStateToProps (state) {
  return { isFetching: selectors.global.isFetching(state.global) };
}

function mapDispatchToProps (dispatch) {
  const creators = Map()
    .merge(...actions)
    .filter(value => typeof value === 'function')
    .toObject();

  return {
    actions: bindActionCreators(creators, dispatch),
    dispatch,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(HomeScreen);



// WEBPACK FOOTER //
// ./src/containers/HomeScreen.js